import React, { useState } from 'react'
import { useTableFilterContext } from './Context'
import { FilterContainerBodyLayout } from './FilterContainer'
import type { TableFilterProps } from './types'
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap'

export const BooleanTableFilter = ({ field }: TableFilterProps) => {
  const { onFilter, getStoredFilter, setShowFilterContainer } = useTableFilterContext()
  const storedValue = getStoredFilter()
  let initialValue = null
  if (storedValue?.$or) initialValue = 'NO'
  else if (storedValue?.$nor) initialValue = 'YES'

  const [radioValue, setRadioValue] = useState(initialValue)

  const filterNow = (value?: string) => {
    const finalValue = value ?? radioValue
    const hasValue = finalValue === 'YES'

    //we check the fields for falsy values using this conditions
    const arrayOfConditions = [
      { [field.name]: { $exists: false } },
      { [field.name]: null },
      //{ [field.name]: '' },
      { [field.name]: false },
    ]
    //we use $nor for YES, and $or for NO values, because we are checking for falsy fields
    const extraFilter = hasValue
      ? {
          [field.name]: {
            $nor: arrayOfConditions,
          },
        }
      : {
          [field.name]: {
            $or: arrayOfConditions,
          },
        }

    onFilter(extraFilter)
  }

  const onChange = (value: string) => {
    setRadioValue(value)
    filterNow(value)
    setShowFilterContainer(false)
  }

  return (
    <FilterContainerBodyLayout>
      <ToggleButtonGroup
        className="d-flex"
        type="radio"
        name="booleanOptions"
        onChange={onChange}
        defaultValue={radioValue}
      >
        <ToggleButton id="tbg-yes" value={'YES'} variant="primary">
          YES
        </ToggleButton>
        <ToggleButton id="tbg-no" value={'NO'} variant="primary">
          NO
        </ToggleButton>
      </ToggleButtonGroup>
    </FilterContainerBodyLayout>
  )
}
